import '../assets/dependencies';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Messages from '../components/layout/Messages';
import Routes from './routes';

const App = () => (
  <BrowserRouter>
    <Routes />
    <Messages />
  </BrowserRouter>
)

export default App;